import React, { useState, useEffect } from "react";
import {
  Dialog,
  Flex,
  Button,
  CloseIcon,
} from "@fluentui/react-northstar";
import CommentInput from "./CommentInput";

const INITIAL_TAG = { key: "positive", value: "Positive", color: "#92C353" };

const CommentDialog = ({ open, onClose, onSubmit, disabled, editingComment, isEditing }) => {
  const [comment, setComment] = useState("");
  const [selectedTag, setSelectedTag] = useState(INITIAL_TAG);

  useEffect(() => {
    if (isEditing && editingComment) {
      setComment(editingComment.text);
      setSelectedTag(INITIAL_TAG); // We'll need to find the matching tag
      const matchingTag = COMMENT_TAGS.find(tag => tag.value === editingComment.tag);
      if (matchingTag) {
        setSelectedTag(matchingTag);
      }
    }
  }, [isEditing, editingComment]);

  const handleAddComment = () => {
    if (comment.trim()) {
      onSubmit({
        text: comment.trim(),
        tag: selectedTag.value,
      });
      handleClose();
    }
  };

  const handleClose = () => {
    setComment("");
    setSelectedTag(INITIAL_TAG);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onOpen={() => { }}
      onCancel={handleClose}
      style={{ width: "600px" }}
      header={isEditing ? "Edit comment" : "Add comment"}
      content={
        <Flex column gap="gap.medium" padding="padding.medium">
          <CommentInput
            comment={comment}
            setComment={setComment}
            selectedTag={selectedTag}
            setSelectedTag={setSelectedTag}
            disabled={disabled}

          />
          <Flex gap="gap.small" hAlign="end">
            <Button content="Cancel" onClick={handleClose} />
            <Button
              content={isEditing ? "Save Changes" : "Add Comment"}
              primary
              onClick={handleAddComment}
              disabled={!comment.trim() || disabled}
              data-cy="submit-comment-btn"
            />
          </Flex>
        </Flex>
      }
      headerAction={{
        icon: <CloseIcon />,
        title: "Close",
        onClick: handleClose,
      }}
    />
  );
};

export default CommentDialog;
